import {
  unauthenticatedSession,
  useAuthApi,
} from '../../../../contexts/AuthContext';
import { useEventHandler } from '../../../../hooks/useEventHandler';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { postLogout } from '../../requests/postLogout';

/**
 * Logs the user out: blacklists the JWT server-side (POST /auth/logout) then
 * clears the local session. The backend call is best-effort, so the user is
 * always logged out locally even if the blacklist request fails.
 *
 * The full navigation to the caller's login screen (rather than reloading in
 * place) both cleans up Echo/Ably and keeps the logged-out page from being
 * boot-captured as a return URL, which the next user to log in on this
 * browser would otherwise be resumed to.
 */
export const useLogout = (loginPath: string) => {
  const { setSession } = useAuthApi();
  const { constructPost } = useRequestConstructor();

  return useEventHandler(async (): Promise<void> => {
    try {
      await postLogout(constructPost);
    } catch {
      // Best effort: still clear the local session on failure.
    }
    setSession(unauthenticatedSession());
    window.location.replace(loginPath);
  });
};
